<template>
  <div>
    <div v-if="dummyFeatureA">Show this, if feature A is active</div>
    <div v-else>Show this, if feature A is <b>in</b>active</div>

    <div v-if="dummyFeatureB">Show this, if feature B is active</div>
    <div v-else>Show this, if feature B is <b>in</b>active</div>
  </div>
</template>

<script>
import useFeature from '@/mixins/useFeature'

export default {
  name: 'FeatureFlag',
  mixins: [
    useFeature('dummyFeatureA'),
    useFeature('dummyFeatureB')
  ]
}
</script>
